/* eslint-disable react/prop-types */
// Adapted from react-icon-base 2.1.0 by gorangajic
// https://github.com/gorangajic/react-icon-base
// Licensed under MIT Open Source

import { default as React } from 'react';
import PropTypes from 'prop-types';
import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper('icon');

const IconBase = (props) => {
  const { children, viewBox, size, width, height, title, className, style, disabled, error, ...otherProps } = props;
  const sizeToStyle = { height: height || size, width: width || size };
  const allStyle = { ...sizeToStyle, ...style };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
      {...classes({
        states: {
          disabled,
          error: error && !disabled,
        },
        extra: className,
      })}
      viewBox={viewBox}
      style={allStyle}
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
};

IconBase.defaultProps = {
  viewBox: '0 0 25 25',
};

IconBase.propTypes = {
  /** Adds a class to the root element of the component */
  className: PropTypes.string,
  /** Adds a state class to the svg */
  disabled: PropTypes.bool,
  /** Adds a state class to the svg (if not also disabled) */
  error: PropTypes.string,
  /** Sets the svg viewBox attribute; changing this is not recommended. */
  viewBox: PropTypes.string,
  /** Sets the size of the icon (a shortcut for setting height and width) */
  size: PropTypes.string,
  /** Sets the width of the icon */
  width: PropTypes.string,
  /** Sets the height of the icon */
  height: PropTypes.string,
  /** Sets the inline content of the `<title>` element in the svg; defaults to the icon's name */
  title: PropTypes.string,
};

export default IconBase;
